import logo1 from "../../assets/img/ple/royal-rumble/logos/1988.png";
import logo2 from "../../assets/img/ple/royal-rumble/logos/1989.png";
import logo3 from "../../assets/img/ple/royal-rumble/logos/1990-1994.png";
import logo4 from "../../assets/img/ple/royal-rumble/logos/1995.png";
import logo5 from "../../assets/img/ple/royal-rumble/logos/1996-1997.png";
import logo6 from "../../assets/img/ple/royal-rumble/logos/1998.png";
import logo7 from "../../assets/img/ple/royal-rumble/logos/1999.png";
import logo8 from "../../assets/img/ple/royal-rumble/logos/2000.png";
import logo9 from "../../assets/img/ple/royal-rumble/logos/2001.png";
import logo10 from "../../assets/img/ple/royal-rumble/logos/2002.png";
import logo11 from "../../assets/img/ple/royal-rumble/logos/2003.png";
import logo12 from "../../assets/img/ple/royal-rumble/logos/2004.png";
import logo13 from "../../assets/img/ple/royal-rumble/logos/2005.png";
import logo14 from "../../assets/img/ple/royal-rumble/logos/2006.png";
import logo15 from "../../assets/img/ple/royal-rumble/logos/2007.png";
import logo16 from "../../assets/img/ple/royal-rumble/logos/2008.png";
import logo17 from "../../assets/img/ple/royal-rumble/logos/2009.png";
import logo18 from "../../assets/img/ple/royal-rumble/logos/2010.png";
import logo19 from "../../assets/img/ple/royal-rumble/logos/2011.png";
import logo20 from "../../assets/img/ple/royal-rumble/logos/2012.png";
import logo21 from "../../assets/img/ple/royal-rumble/logos/2013-2014.png";
import logo22 from "../../assets/img/ple/royal-rumble/logos/2015.png";
import logo23 from "../../assets/img/ple/royal-rumble/logos/2016.png";
import logo24 from "../../assets/img/ple/royal-rumble/logos/2017-2018.png";
import logo25 from "../../assets/img/ple/royal-rumble/logos/2019-2020.png";
import logo26 from "../../assets/img/ple/royal-rumble/logos/2021.png";
import logo27 from "../../assets/img/ple/royal-rumble/logos/2022-2024.png";
import logo28 from "../../assets/img/ple/royal-rumble/logos/2025.png";
import logo29 from "../../assets/img/ple/royal-rumble/logos/2026.png";

import winner1 from "../../assets/img/ple/royal-rumble/winners/JimDuggan.png";
import winner2 from "../../assets/img/ple/royal-rumble/winners/BigJohnStudd.png";
import winner3 from "../../assets/img/ple/royal-rumble/winners/HulkHogan.png";
import winner5 from "../../assets/img/ple/royal-rumble/winners/RicFlair.png";
import winner6 from "../../assets/img/ple/royal-rumble/winners/Yokozuna.png";
import winner7 from "../../assets/img/ple/royal-rumble/winners/Hart&Luger.png";
import winner8 from "../../assets/img/ple/royal-rumble/winners/ShawnMichaels.png";
import winner10 from "../../assets/img/ple/royal-rumble/winners/StoneCold.png";
import winner12 from "../../assets/img/ple/royal-rumble/winners/Vince.png";
import winner13 from "../../assets/img/ple/royal-rumble/winners/Rock.png";
import winner14 from "../../assets/img/ple/royal-rumble/winners/StoneCold2.png";
import winner15 from "../../assets/img/ple/royal-rumble/winners/TripleH.png";
import winner16 from "../../assets/img/ple/royal-rumble/winners/BrockLesnar.png";
import winner17 from "../../assets/img/ple/royal-rumble/winners/ChrisBenoit.png";
import winner18 from "../../assets/img/ple/royal-rumble/winners/Batista.png";
import winner19 from "../../assets/img/ple/royal-rumble/winners/ReyMysterio.png";
import winner20 from "../../assets/img/ple/royal-rumble/winners/Undertaker.png";
import winner21 from "../../assets/img/ple/royal-rumble/winners/JohnCena.png";
import winner22 from "../../assets/img/ple/royal-rumble/winners/RandyOrton.png";
import winner23 from "../../assets/img/ple/royal-rumble/winners/Edge.png";
import winner24 from "../../assets/img/ple/royal-rumble/winners/Alberto.png";
import winner25 from "../../assets/img/ple/royal-rumble/winners/Sheamus.png";
import winner26 from "../../assets/img/ple/royal-rumble/winners/JohnCena2.png";
import winner27 from "../../assets/img/ple/royal-rumble/winners/Batista2.png";
import winner28 from "../../assets/img/ple/royal-rumble/winners/RomanReigns.png";
import winner29 from "../../assets/img/ple/royal-rumble/winners/TripleH2.png";
import winner30 from "../../assets/img/ple/royal-rumble/winners/RandyOrton2.png";
import winner31 from "../../assets/img/ple/royal-rumble/winners/ShinsukeNakamura.png";
import winner32 from "../../assets/img/ple/royal-rumble/winners/SethRollins.png";
import winner33 from "../../assets/img/ple/royal-rumble/winners/DrewMcIntyre.png";
import winner34 from "../../assets/img/ple/royal-rumble/winners/Edge2.png";
import winner35 from "../../assets/img/ple/royal-rumble/winners/BrockLesnar2.png";
import winner36 from "../../assets/img/ple/royal-rumble/winners/CodyRhodes.png";
import winner38 from "../../assets/img/ple/royal-rumble/winners/JeyUso.png";
import winner39 from "../../assets/img/ple/royal-rumble/winners/RomanReigns2.png";

export const royalRumbleEventDetails = {
  "royal-rumble": {
    id: "royal-rumble",
    title: "Royal Rumble",
    subtitle: "Explore winners and event editions in a dedicated event view.",
    tabs: [
      {
        id: "winners",
        label: "Winners",
        variant: "royal-rumble",
        items: [
          {
            id: "mens-rumble",
            title: "´Hacksaw´ Jim Duggan",
            description: "1988",
            imgUrl: winner1,
          },
          {
            id: "mens-rumble-2",
            title: "Big John Studd",
            description: "1989",
            imgUrl: winner2,
          },
          {
            id: "mens-rumble-3",
            title: "Hulk Hogan",
            description: "1990 - 1991",
            imgUrl: winner3,
          },
          {
            id: "mens-rumble-4",
            title: "Ric Flair",
            description: "1992",
            imgUrl: winner5,
          },
          {
            id: "mens-rumble-5",
            title: "Yokozuna",
            description: "1993",
            imgUrl: winner6,
          },
          {
            id: "mens-rumble-6",
            title: "Bret Hart & Lex Luger",
            description: "1994",
            imgUrl: winner7,
          },
          {
            id: "mens-rumble-7",
            title: "Shawn Michaels",
            description: "1995 - 1996",
            imgUrl: winner8,
          },
          {
            id: "mens-rumble-8",
            title: "´Stone Cold´ Steve Austin",
            description: "1997 - 1998",
            imgUrl: winner10,
          },
          {
            id: "mens-rumble-9",
            title: "Vince McMahon",
            description: "1999",
            imgUrl: winner12,
          },
          {
            id: "mens-rumble-10",
            title: "The Rock",
            description: "2000",
            imgUrl: winner13,
          },
          {
            id: "mens-rumble-11",
            title: "´Stone Cold´ Steve Austin",
            description: "2001",
            imgUrl: winner14,
          },
          {
            id: "mens-rumble-12",
            title: "Triple H",
            description: "2002",
            imgUrl: winner15,
          },
          {
            id: "mens-rumble-13",
            title: "Brock Lesnar",
            description: "2003",
            imgUrl: winner16,
          },
          {
            id: "mens-rumble-14",
            title: "Chris Benoit",
            description: "2004",
            imgUrl: winner17,
          },
          {
            id: "mens-rumble-15",
            title: "Batista",
            description: "2005",
            imgUrl: winner18,
          },
          {
            id: "mens-rumble-16",
            title: "Rey Mysterio",
            description: "2006",
            imgUrl: winner19,
          },
          {
            id: "mens-rumble-17",
            title: "The Undertaker",
            description: "2007",
            imgUrl: winner20,
          },
          {
            id: "mens-rumble-18",
            title: "John Cena",
            description: "2008",
            imgUrl: winner21,
          },
          {
            id: "mens-rumble-19",
            title: "Randy Orton",
            description: "2009",
            imgUrl: winner22,
          },
          {
            id: "mens-rumble-20",
            title: "Edge",
            description: "2010",
            imgUrl: winner23,
          },
          {
            id: "mens-rumble-21",
            title: "Alberto Del Rio",
            description: "2011",
            imgUrl: winner24,
          },
          {
            id: "mens-rumble-22",
            title: "Sheamus",
            description: "2012",
            imgUrl: winner25,
          },
          {
            id: "mens-rumble-23",
            title: "John Cena",
            description: "2013",
            imgUrl: winner26,
          },
          {
            id: "mens-rumble-24",
            title: "Batista",
            description: "2014",
            imgUrl: winner27,
          },
          {
            id: "mens-rumble-25",
            title: "Roman Reigns",
            description: "2015",
            imgUrl: winner28,
          },
          {
            id: "mens-rumble-26",
            title: "Triple H",
            description: "2016",
            imgUrl: winner29,
          },
          {
            id: "mens-rumble-27",
            title: "Randy Orton",
            description: "2017",
            imgUrl: winner30,
          },
          {
            id: "mens-rumble-28",
            title: "Shinsuke Nakamura",
            description: "2018",
            imgUrl: winner31,
          },
          {
            id: "mens-rumble-29",
            title: "Seth Rollins",
            description: "2019",
            imgUrl: winner32,
          },
          {
            id: "mens-rumble-30",
            title: "Drew McIntyre",
            description: "2020",
            imgUrl: winner33,
          },
          {
            id: "mens-rumble-31",
            title: "Edge",
            description: "2021",
            imgUrl: winner34,
          },
          {
            id: "mens-rumble-32",
            title: "Brock Lesnar",
            description: "2022",
            imgUrl: winner35,
          },
          {
            id: "mens-rumble-33",
            title: "Cody Rhodes",
            description: "2023 - 2024",
            imgUrl: winner36,
          },
          {
            id: "mens-rumble-34",
            title: "Jey Uso",
            description: "2025",
            imgUrl: winner38,
          },
          {
            id: "mens-rumble-35",
            title: "Roman Reigns",
            description: "2026",
            imgUrl: winner39,
          },
        ],
      },
      {
        id: "logos",
        label: "Editions",
        variant: "royal-rumble",
        items: [
          {
            id: "logo1",
            title: "Royal Rumble",
            description: "1988",
            imgUrl: logo1,
          },
          {
            id: "logo2",
            title: "Royal Rumble",
            description: "No Partners...30 Opponents 1989",
            imgUrl: logo2,
          },
          {
            id: "logo3-1990",
            title: "Royal Rumble",
            description: "Every Man for Himself! 1990",
            imgUrl: logo3,
          },
          {
            id: "logo3-1991",
            title: "Royal Rumble",
            description:
              "Friend vs. Friend, Foe vs. Foe. It's Every Man for Himself! 1991",
            imgUrl: logo3,
          },
          {
            id: "logo3-1992-1994",
            title: "Royal Rumble",
            description: "1992 - 1994",
            imgUrl: logo3,
          },
          {
            id: "logo4",
            title: "Royal Rumble",
            description: "30 Men, 1 Winner, Something's Gotta Give! 1995",
            imgUrl: logo4,
          },
          {
            id: "logo5-1996",
            title: "Royal Rumble",
            description: "You've been WARNED! 1996",
            imgUrl: logo5,
          },
          {
            id: "logo5-1997",
            title: "Royal Rumble",
            description: "No More Mr. Nice Guy! 1997",
            imgUrl: logo5,
          },
          {
            id: "logo6",
            title: "Royal Rumble",
            description: "	Pain! Just a four letter word. 1998",
            imgUrl: logo6,
          },
          {
            id: "logo7",
            title: "Royal Rumble",
            description: "	No Chance in Hell 1999",
            imgUrl: logo7,
          },
          {
            id: "logo8",
            title: "Royal Rumble",
            description: "The Road to WrestleMania Begins 2000",
            imgUrl: logo8,
          },
          {
            id: "logo9",
            title: "Royal Rumble",
            description: "30 men. Every man for himself. One victor. 2001",
            imgUrl: logo9,
          },
          {
            id: "logo10",
            title: "Royal Rumble",
            description: "30 Men, One Match, One W1nner 2002",
            imgUrl: logo10,
          },
          {
            id: "logo11",
            title: "Royal Rumble",
            description: "'Falling Apart' de Trust Company 2003",
            imgUrl: logo11,
          },
          {
            id: "logo12",
            title: "Royal Rumble",
            description: "'Nothing Left To Lose' de Puddle of Mudd 2004",
            imgUrl: logo12,
          },
          {
            id: "logo13",
            title: "Royal Rumble",
            description: "All the rumbling, minus the dancing and singing 2005",
            imgUrl: logo13,
          },
          {
            id: "logo14",
            title: "Royal Rumble",
            description: "2006",
            imgUrl: logo14,
          },
          {
            id: "logo15",
            title: "Royal Rumble",
            description: "2007",
            imgUrl: logo15,
          },
          {
            id: "logo16",
            title: "Royal Rumble",
            description: "2008",
            imgUrl: logo16,
          },
          {
            id: "logo17",
            title: "Royal Rumble",
            description: "2009",
            imgUrl: logo17,
          },
          {
            id: "logo18",
            title: "Royal Rumble",
            description: "I Am The One 2010",
            imgUrl: logo18,
          },
          {
            id: "logo19",
            title: "Royal Rumble",
            description: "The Biggest Royal Rumble in History 2011",
            imgUrl: logo19,
          },
          {
            id: "logo20",
            title: "Royal Rumble",
            description: "2012",
            imgUrl: logo20,
          },
          {
            id: "logo21-2013",
            title: "Royal Rumble",
            description: "Finally... 2013",
            imgUrl: logo21,
          },
          {
            id: "logo21-2014",
            title: "Royal Rumble",
            description: "2014",
            imgUrl: logo21,
          },
          {
            id: "logo22",
            title: "Royal Rumble",
            description: "2015",
            imgUrl: logo22,
          },
          {
            id: "logo23",
            title: "Royal Rumble",
            description: "2016",
            imgUrl: logo23,
          },
          {
            id: "logo24-2017",
            title: "Royal Rumble",
            description: "Remember the Rumble 2017",
            imgUrl: logo24,
          },
          {
            id: "logo24-2018",
            title: "Royal Rumble",
            description: "2018",
            imgUrl: logo24,
          },
          {
            id: "logo25",
            title: "Royal Rumble",
            description: "2019 - 2020",
            imgUrl: logo25,
          },
          {
            id: "logo26",
            title: "Royal Rumble",
            description: "2021",
            imgUrl: logo26,
          },
          {
            id: "logo27",
            title: "Royal Rumble",
            description: "2022 - 2024",
            imgUrl: logo27,
          },
          {
            id: "logo28",
            title: "Royal Rumble",
            description: "Indianapolis 2025",
            imgUrl: logo28,
          },
          {
            id: "logo29",
            title: "Royal Rumble",
            description: "Riyadh 2026",
            imgUrl: logo29,
          },
        ],
      },
    ],
  },
};
